const tr: Record<string, string> = {
  '{{count}} ürün': '{{count}} ürün',
  '{{count}}/500 karakter': '{{count}}/500 karakter',
}

export default tr
